/** Default settings for each predefined animation. */
export const wvrAnimationDefaults = {
  fade: {
    from: 1,
    to: 0,
    timing: '250ms linear'
  },
  fadeToggle: {
    from: 1,
    to: 0,
    timing: '250ms linear'
  },
  rotate: {
    from: 0,
    to: 90,
    timing: '250ms linear'
  },
  rotateToggle: {
    from: 0,
    to: 90,
    timing: '250ms linear'
  },
  expandCollapse: {
    from: '*',
    to: '0px',
    timing: '250ms linear'
  },
  expandCollapseToggle: {
    from: '*',
    to: '0px',
    timing: '250ms linear'
  }
};
